module.exports = __webpack_public_path__ + "img/checkedMaterialEditor.dfb1bb77.png";